/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * All of the possible `DialogSize*`'s.
 */
export type DialogSize = DialogSizeSM | DialogSizeSM_MD | DialogSizeMD | DialogSizeLG | DialogSizeXL;

/**
 * The Dialog small size type.
 */
export type DialogSizeSM = typeof DIALOG_SIZE_SM;

/**
 * The Dialog small-medium size type.
 */
export type DialogSizeSM_MD = typeof DIALOG_SIZE_SM_MD;

/**
 * The Dialog medium size type.
 */
export type DialogSizeMD = typeof DIALOG_SIZE_MD;

/**
 * The Dialog large size type.
 */
export type DialogSizeLG = typeof DIALOG_SIZE_LG;

/**
 * The Dialog extra large size type.
 */
export type DialogSizeXL = typeof DIALOG_SIZE_XL;

/**
 * The Dialog small size constant.
 */
export const DIALOG_SIZE_SM = `sm`;

/**
 * The Dialog small-medium size constant.
 */
export const DIALOG_SIZE_SM_MD = `sm-md`;

/**
 * The Dialog medium size constant.
 */
export const DIALOG_SIZE_MD = `md`;

/**
 * The Dialog large size constant.
 */
export const DIALOG_SIZE_LG = `lg`;

/**
 * The Dialog extra large size constant.
 */
export const DIALOG_SIZE_XL = `xl`;
